import React from 'react';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import usePageTitle from '../hooks/UsePageTitle';
const WhyUs = () => {
  usePageTitle('Why Choose Us | SnP Finvisors');

  return (
    <div className="page-container">
      <div className="grid">
        {/* Hero Section */}
        <div className="col-12">
          <div className="hero-section p-5 border-round mb-5" style={{ 
            background: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(https://images.unsplash.com/photo-1454165804606-c3d57bc86b40)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: 'white'
          }}>
            <h1 className="text-5xl font-bold mb-3">Why Choose SnP Finvisors</h1>
            <p className="text-xl line-height-3">
              Beyond conventional consulting - your trusted partner in business growth
            </p>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="col-12">
          <div className="text-center mb-6">
            <h2 className="text-3xl mb-3">What sets us Apart</h2>
            <Divider className="w-4 mx-auto" />
            <p className="text-xl line-height-3 mx-auto" style={{ maxWidth: '800px' }}>
              We go beyond conventional consulting to deliver solutions that drive business success and become your trusted partner in business growth.
            </p>
          </div>
        </div>

        {/* Image + Features */}
        <div className="col-12 md:col-6">
          <img 
            src='/images/tax1.jpg' 
            alt="Why Choose Us" 
            className="w-full border-round shadow-2" 
            style={{ maxHeight: '600px', objectFit: 'cover' }}
          />
        </div>
        <div className="col-12 md:col-6">
          <div className="grid">
            {/* Comprehensive Support */}
            <div className="col-12">
              <Card className="mb-3">
                <div className="flex align-items-start">
                  <i className="pi pi-cog text-primary text-2xl mr-3 mt-1"></i>
                  <div>
                    <h3 className="mt-0 mb-2">Comprehensive Business Support</h3>
                    <p className="m-0">
                      We provide a full spectrum of financial, compliance, and business process automation services, 
                      ensuring seamless operations while you focus on growth.
                    </p>
                  </div>
                </div>
              </Card>
            </div>

            {/* SME Focus */}
            <div className="col-12">
              <Card className="mb-3">
                <div className="flex align-items-start">
                  <i className="pi pi-briefcase text-primary text-2xl mr-3 mt-1"></i>
                  <div>
                    <h3 className="mt-0 mb-2">Tailored for SMEs & Educational Institutions</h3>
                    <p className="m-0">
                      Our expertise spans multiple industries, with a specialized division dedicated to addressing 
                      the unique needs of the education sector.
                    </p>
                  </div>
                </div>
              </Card>
            </div>

            {/* Technology */}
            <div className="col-12">
              <Card className="mb-3">
                <div className="flex align-items-start">
                  <i className="pi pi-desktop text-primary text-2xl mr-3 mt-1"></i>
                  <div>
                    <h3 className="mt-0 mb-2">Process-Driven & Technology-Enabled</h3>
                    <p className="m-0">
                      We leverage automation and technology to optimize financial processes, enhance efficiency, 
                      and reduce operational bottlenecks.
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>

        {/* Additional Features */}
        <div className="col-12 mt-4">
          <div className="grid">
            {/* Compliance */}
            <div className="col-12 md:col-6 lg:col-4">
              <Card className="h-full">
                <div className="flex flex-column align-items-center text-center">
                  <i className="pi pi-shield text-primary text-5xl mb-3"></i>
                  <h3 className="text-xl mt-0">Proactive Compliance & Risk Management</h3>
                  <Divider className="w-4" />
                  <p>
                    Stay ahead of regulations with our expert guidance, ensuring your business remains compliant and risk-free.
                  </p>
                </div>
              </Card>
            </div>

            {/* Growth */}
            <div className="col-12 md:col-6 lg:col-4">
              <Card className="h-full">
                <div className="flex flex-column align-items-center text-center">
                  <i className="pi pi-chart-line text-primary text-5xl mb-3"></i>
                  <h3 className="text-xl mt-0">Growth-Centric Partnership</h3>
                  <Divider className="w-4" />
                  <p>
                    We don't just solve problems; we work alongside you to create strategies that enhance profitability, 
                    scalability, and long-term success.
                  </p>
                </div>
              </Card>
            </div>

            {/* Integrity */}
            <div className="col-12 md:col-6 lg:col-4">
              <Card className="h-full">
                <div className="flex flex-column align-items-center text-center">
                  <i className="pi pi-heart text-primary text-5xl mb-3"></i>
                  <h3 className="text-xl mt-0">Integrity & Professional Excellence</h3>
                  <Divider className="w-4" />
                  <p>
                    Our team of experienced Chartered Accountants is committed to delivering reliable, ethical, 
                    and high-quality solutions tailored to your needs.
                  </p>
                </div>
              </Card>
            </div>

            {/* Cost Effective */}
            <div className="col-12 md:col-6 lg:col-4 mt-4">
              <Card className="h-full">
                <div className="flex flex-column align-items-center text-center">
                  <i className="pi pi-wallet text-primary text-5xl mb-3"></i>
                  <h3 className="text-xl mt-0">Cost-Effective Services</h3>
                  <Divider className="w-4" />
                  <p>
                    We offer value-driven solutions designed to maximize efficiency while keeping costs in check, 
                    ensuring affordability without compromising on quality.
                  </p>
                </div>
              </Card>
            </div>

            {/* Custom Solutions */}
            <div className="col-12 md:col-6 lg:col-4 mt-4">
              <Card className="h-full">
                <div className="flex flex-column align-items-center text-center">
                  <i className="pi pi-palette text-primary text-5xl mb-3"></i>
                  <h3 className="text-xl mt-0">Customized Solutions</h3>
                  <Divider className="w-4" />
                  <p>
                    Every business is unique. We take time to understand your specific challenges and design 
                    solutions that fit your exact requirements.
                  </p>
                </div>
              </Card>
            </div>

            {/* Dedicated Support */}
            <div className="col-12 md:col-6 lg:col-4 mt-4">
              <Card className="h-full">
                <div className="flex flex-column align-items-center text-center">
                  <i className="pi pi-headset text-primary text-5xl mb-3"></i>
                  <h3 className="text-xl mt-0">Dedicated Support</h3>
                  <Divider className="w-4" />
                  <p>
                    Our team is always available to address your concerns and provide timely assistance 
                    whenever you need it.
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>

        {/* Testimonials or CTA can be added here */}
        <div className="col-12 mt-6">
          <Card className="surface-100">
            <h2 className="text-center text-3xl mt-0">Ready to Grow Your Business?</h2>
            <Divider className="w-4 mx-auto" />
            <p className="text-center text-xl line-height-3" style={{ maxWidth: '800px', margin: '0 auto' }}>
              Partner with SnP Finvisors and experience the difference of working with a team that's truly invested in your success. 
              Let's discover how we can elevate your business performance.
            </p>
            <div className="flex justify-content-center mt-4">
              <button className="p-button p-button-primary p-button-lg">
                Let's Connect
              </button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;